import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Button } from './Button';

export const ContextCSS = css`
  position: fixed;
  z-index: 2;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  background: #15202b;
  justify-content: center;
`;
const Wrapper = styled.div`
  ${ContextCSS}
  min-height: 50vh;
  max-height: 50vh;
`;
const Close = styled.div`
  position: absolute;
  top: -2.5vmin;
  right: 2vmin;
`;
const WrapperContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2vmin;
  gap: 2vmin;
  overflow: scroll;
  justify-content: start;
  align-items: center;
`;

export const Context = ({
  children,

  onClose,
}: {
  children: ReactNode;
  onClose: () => void;
}) => {
  return (
    <Wrapper>
      <Close>
        <Button
          color="red"
          size="L"
          onClick={() => {
            onClose();
          }}
        >
          &times;
        </Button>
      </Close>
      <WrapperContent>{children}</WrapperContent>
    </Wrapper>
  );
};
